<template>
  <div class="pt-3">
    <v-form @submit.prevent="searchUp">
      <v-col class="d-flex">
        <v-text-field
          v-model="searchKey"
          hide-details="auto"
          label="Search"
          outlined
          autofocus
          dense
          clearable
        />
        <v-btn
          :disabled="!searchKey"
          class="info ml-2"
          type="submit"
        >
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </v-col>
    </v-form>
    <v-col>
      <template v-if="show">
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Added at
                </th>
                <th class="text-left">
                  SKU
                </th>
                <th class="text-left">
                  Barcode
                </th>
                <th class="text-left">
                  name
                </th>
                <th class="text-left">
                  Price
                </th>
                <th class="text-left">
                  Quantity
                </th>
                <th class="text-left">
                  IMEI
                </th>
                <th class="text-left">
                  Serial Number
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-if="searched.length > 0">
                <tr
                  v-for="item in searched"
                  :key="item.id"
                >
                  <td>{{ item.created_at }}</td>
                  <td>{{ item.sku }}</td>
                  <td>{{ item.barcode }}</td>
                  <td>{{ item.name | capitalize }}</td>
                  <td>{{ item.price | currency }}</td>
                  <td>{{ item.qty }}</td>
                  <td>{{ item.imei }}</td>
                  <td>{{ item.sNumber }}</td>
                </tr>
              </template>
              <template v-else>
                <tr>
                  <td
                    colspan="6"
                    class="error--text"
                  >
                    Not found
                  </td>
                </tr>
              </template>
            </tbody>
          </template>
        </v-simple-table>
      </template>
      <template v-else>
        <strong>Tip :</strong>
        <p>
          Search product with following keys
        </p>
        <ul>
          <li>By Product Name</li>
          <li>By SKU</li>
          <li>By Barcode</li>
          <li>By IMIE</li>
          <li>By Serial Number</li>
        </ul>
      </template>
    </v-col>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      searchKey: "",
      searched: [],
    };
  },
  watch: {
    searchKey() {
      if (this.searchKey === "" || this.searchKey === null) {
        this.$data.searched = [];
        this.$data.show = false;
      }
    },
  },
  methods: {
    searchUp() {
      window.axios
        .post("/product-search", { key: this.searchKey })
        .then((response) => {
          this.$data.show = true;
          this.$data.searched = response.data.items;
        });
    },
  },
};
</script>
